module.exports = __webpack_public_path__ + "images/frontpage_eye@3x.png?6d28b979";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_eye@3x.png
// module id = 641
// module chunks = 7